import React, { Component } from 'react';
import { Modal, InputNumber, Spin, message } from 'antd';
import Text from '../../basicElement/Text';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import moment from 'moment';

class SpecificAdjustFte extends Component {
    state = {
        record: {},
        beforeStart: [],
        afterStart: [],
        loading: false,
        visible: false,
    }

    loadData = () => {
        const { record } = this.state;
        const { invId, invState } = sessionStorage;
        const { detailInvId } = this.props;
        const { date, investigationSiteId } = record;
        const options = {
            url: API_URL.plan.queryInvestigationFinishedPercentageMonth,
            data: {
                year: moment(date).year(),
                month: moment(date).month() + 1,
                invId: invState == 0 ? detailInvId : invId,
                siteId: investigationSiteId,
            },
            dataType: 'json',
            doneResult: res => {
                const { beforeStart, afterStart } = res;
                this.setState({
                    beforeStart,
                    afterStart,
                });
            }
        };
        $.sendRequest(options);
    }

    show = (record) => {
        this.setState({
            record,
            visible: true
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key) => {
        const { beforeStart, afterStart } = this.state;
        if (key === 'before') {
            beforeStart[0].planFte = value
        } else {
            afterStart[0].planFte = value
        }
        this.setState({ beforeStart, afterStart });
    }

    getContent = () => {
        const { record, beforeStart = [], afterStart = [] } = this.state;
        const { investigationSiteCode, investigationSiteName, date } = record;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div style={{ margin: '0px 30px' }}>中心编号：{investigationSiteCode}</div>
                    <div>中心名称：{investigationSiteName}</div>
                </li>
                <li className="modal-item">
                    <div style={{ marginLeft: 30 }}>时间：{moment(date).format('YYYY-MM')}</div>
                </li>

                {beforeStart[0] &&
                    <li className="modal-item">
                        <div className="item-left"><Text asterisk={true} colon={true}>启动前计划FTE</Text></div>
                        <div className="item-right">
                            <InputNumber
                                step={0.1}
                                precision={2}
                                placeholder="请输入"
                                value={(beforeStart[0] || {}).planFte}
                                style={{ width: 120 }}
                                onChange={value => this.handleChange(value, 'before')}
                            />
                        </div>
                    </li>
                }
                {afterStart[0] &&
                    <li className="modal-item">
                        <div className="item-left"><Text asterisk={true} colon={true}>启动后计划FTE</Text></div>
                        <div className="item-right">
                            <InputNumber
                                step={0.1}
                                precision={2}
                                placeholder="请输入"
                                value={(afterStart[0] || {}).planFte}
                                style={{ width: 120 }}
                                onChange={value => this.handleChange(value, 'after')}
                            />
                        </div>
                    </li>
                }
            </ul>
        );
    }

    confirm = () => {
        this.setState({ loading: true });
        const { beforeStart = [], afterStart = [], record: { investigationSiteId }  } = this.state;
        const { invId } = sessionStorage;
        if (beforeStart.length !== 0) {
            beforeStart[0].fteType = 'before';
        }
        if (afterStart.length !== 0) {
            afterStart[0].fteType = 'after';
        }
        const data = [ ...beforeStart, ...afterStart ];
        let sendParams = {};
        data.filter(row => row.sitePlanFteDetailId).map((el, index) => {
            sendParams[`siteMonthPlanFteUpdateDtos[${index}].detailId`] = el.sitePlanFteDetailId;
            sendParams[`siteMonthPlanFteUpdateDtos[${index}].fte`] = el.planFte;
            sendParams[`siteMonthPlanFteUpdateDtos[${index}].year`] = el.yearNum;
            sendParams[`siteMonthPlanFteUpdateDtos[${index}].month`] = el.monthNum;
            sendParams[`siteMonthPlanFteUpdateDtos[${index}].fteType`] = el.fteType;;
        });
        const options = {
            url: API_URL.plan.updateSiteMonthPlanFte,
            data: {
                ...sendParams,
                siteId: investigationSiteId,
                invId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title='FTE调整'
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content form-list fortyPercentage" style={{padding: 0}}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default SpecificAdjustFte;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/SpecificAdjustFte.js